import { useCallback } from 'react';

import { componentsFactory, useActionsFactory } from '../factories';
import type { SharingModalProps } from '../types';

type HookReturnType = {
	data: ReturnType<typeof componentsFactory>;
	actions: ReturnType<typeof useActionsFactory>;
};

export function useSharingModal(props: SharingModalProps): HookReturnType {
	const { primaryAction, secondaryAction } = useActionsFactory(props);
	const components = useCallback(() => {
		return componentsFactory(props);
	}, [props]);

	const actions = useCallback(() => {
		return {
			primaryAction,
			secondaryAction,
		};
	}, [primaryAction, secondaryAction]);

	return {
		data: {
			...components(),
		},
		actions: {
			...actions(),
		},
	};
}
